var React = require('react');

function MoreVert (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 16c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 12c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"}));
}

MoreVert.displayName = "MoreVert";

MoreVert.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = MoreVert;

MoreVert.default = MoreVert;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/more_vert.svg